import { useSearchParams } from "react-router-dom"
import { readLandingMarket } from "./landingMarket"

export function useLandingMarket() {
  const [searchParams] = useSearchParams()
  return readLandingMarket(searchParams)
}
